import React from 'react';
import ReactDOM from 'react-dom';
import Render from './Render';
//this is index file
ReactDOM.render(<Render />,document.getElementById('root'));

